import React from 'react';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const CkEditor = ({ value, onChange,user }) => {
    return (
        <div className="m1-1 font-sans">
            <CKEditor
                editor={ClassicEditor}
                data={value}
                disabled={user?.responsibilities === "view"||user?.responsibilities === "approver"}
                config={{
                    isReadOnly: user?.responsibilities === "view" ||user?.responsibilities === "approver"
                }}
                onChange={(event, editor) => {
                    if (user?.responsibilities !== "view"&&user?.responsibilities !== "approver") {
                    const data = editor.getData();
                    onChange(data);}
                }}
            />
        </div>
    );
};

export default CkEditor;
